import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { map, Observable } from 'rxjs';
import { EventDocumentModelDto, EventDocumentModelRTFDto } from '@shared/interfaces/dtos/events';
import { CompliantExtractGenerationRightsDto } from '@shared/interfaces/dtos/compliant-extracts';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService extends BaseHttpService {
  //Endpoint will be set dynamically in methods
  protected endPoint: string = '';

  public fetchEventDocumentModels(options?: { meetingTypeId: number }): Observable<EventDocumentModelDto[]> {
    return this.http.get<EventDocumentModelDto[]>(this.buildURL({ overrideEndPoint: 'Global/ModelesEvenements' })).pipe(
      map((res) => {
        const { meetingTypeId } = options || {};

        if (meetingTypeId) {
          return res.filter((model: EventDocumentModelDto) => model.typeSeanceId === meetingTypeId);
        }

        return res;
      })
    );
  }

  public fetchCompliantExtractsGenerationRights(config: {
    meetingId: number;
    documentModelId: number;
    pointsIds: number[];
  }): Observable<CompliantExtractGenerationRightsDto> {
    const { meetingId, documentModelId, pointsIds } = config;

    return this.http.post<CompliantExtractGenerationRightsDto>(
      this.buildURL({
        overrideEndPoint: `Seances/${meetingId}/ExtraitConformes/${documentModelId}/MassGenerationCheck`,
      }),
      { pointIds: pointsIds }
    );
  }

  public downloadEventDocumentModelRTF(documentModelId: number): Observable<Blob> {
    this.endPoint = `Global/ModelesEvenements/${documentModelId}/RTF`;

    return this.http.get<Blob>(this.buildURL(), {
      responseType: 'blob' as 'json',
    });
    // .pipe(map((res) => new Blob([res.rtf], { type: 'application/rtf' })));
  }
}
